import { useQuery } from "@tanstack/react-query";
import {
  TenantBrandingDetails,
  TenantDetails,
  TenantUserFieldDetails,
} from "features/types";
import { get } from "services/http";

export const useFetchTenantUserFieldsQuery = (tenantId: number | undefined) => {
  return useQuery(
    ["fetchTenantUserFields", tenantId],
    () => {
      if (tenantId) {
        return get({
          url: `/tenant/fields/${tenantId}`,
        }) as Promise<Array<TenantUserFieldDetails>>;
      } else {
        return Promise.resolve([]);
      }
    },
    {
      staleTime: Infinity,
    }
  );
};

export const useFetchTenantBrandingQuery = (enabled: boolean = true) => {
  return useQuery(
    ["fetchTenantBranding"],
    () => {
      return get({
        url: "/tenant/branding",
      }) as Promise<TenantBrandingDetails>;
    },
    {
      // Do not refetch when the page reactivates
      staleTime: Infinity,
      enabled,
    }
  );
};

export const useFetchTenantDetailsQuery = () => {
  return useQuery(
    ["fetchTenantDetails"],
    () => {
      return get({
        url: "/tenant",
      }) as Promise<TenantDetails>;
    },
    {
      staleTime: Infinity,
    }
  );
};
